export default {
  thresholdsList: '/configure/thresholds',
  messaging: '/configure/messaging',
}
